module.exports = __webpack_public_path__ + "img/logo.30ae37e9.png";